export const environment = {
  production: true,
  firebaseConfig : {
    apiKey: "AIzaSyCzpRvd2HiPQFO0rGlXxRbnvKrXMnl81LA",
    authDomain: "meri-samruddhi.firebaseapp.com",
    projectId: "meri-samruddhi",
    storageBucket: "meri-samruddhi.appspot.com",
    messagingSenderId: "501850242526",
    appId: "1:501850242526:web:95d039fb6fd05c5fdff14f",
    measurementId: "G-P9VDD3TS99"
  }
};
